import React from "react";
import { motion } from "framer-motion";
import { FlameIcon } from "lucide-react";
const TOTAL_SPOTS = 100;
const SPOTS_LEFT = 7;
export function ScarcityBar() {
  const filled = (TOTAL_SPOTS - SPOTS_LEFT) / TOTAL_SPOTS * 100;
  return <div className="mx-auto w-full max-w-xl" data-id="element-51" data-mp="2l4o1p39evveh">
      <div className="mb-2 flex items-center justify-between gap-3 text-sm" data-id="element-52" data-mp="2q3hfyxwivqfp">
        <span className="flex items-center gap-1.5 font-bold text-white" data-id="element-53" data-mp="2q1oavn1k5e9t">
          <FlameIcon className="h-4 w-4 text-orange-400" aria-hidden="true" data-id="element-54" data-mp="2b5fbmlho30xe" />
          Only <span className="text-orange-300" data-id="element-55" data-mp="2g6mm4sb72e7r">{SPOTS_LEFT} spots</span> left at $27
        </span>
        <span className="font-semibold tabular-nums text-slate-300" data-id="element-56" data-mp="227dcycleokda">{filled}% claimed</span>
      </div>
      <div className="h-4 w-full overflow-hidden rounded-full bg-ink-950 ring-1 ring-white/10" role="progressbar" aria-valuenow={filled} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-57" data-mp="275y7bvdz89tt">
        <motion.div className="h-full rounded-full bg-orange-500" initial={{
        width: "0%"
      }} whileInView={{
        width: `${filled}%`
      }} viewport={{
        once: true
      }} transition={{
        duration: 1.1,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-58" data-mp="5d0fo2vxrnag" />
      </div>
      <p className="mt-2 text-center text-xs text-slate-400" data-id="element-59" data-mp="3dc6dpzu3e3qg">When the spots run out, the price returns to its regular value.</p>
    </div>;
}